import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { defineComponent, ref, defineProps, onMounted } from 'vue'
import { rootDownLoadPath } from '../config'
import { getI18n, isEmptyString } from '../utils'

const __default__ = defineComponent({
  name: 'LinkItem'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  dataValue: {
    type: String,
    require: true
  }
},
  setup(__props) {

const props = __props

const refTitle = ref('')
const refLink = ref('')
onMounted(async () => {
  if (isEmptyString(props.dataValue)) {
    return
  }
  const parts = props.dataValue.split('|||')
  refTitle.value = parts[0]
  console.log(props.dataValue)
  if (parts.length < 3) {
    refLink.value = rootDownLoadPath + parts[1]
  } else {
    refLink.value = '/action?__action_id=' + parts[2] + '&__file_path=' + parts[1]
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createBlock(_component_el_link, {
    type: "primary",
    href: refLink.value,
    target: "_blank"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(getI18n)(refTitle.value)), 1)
    ]),
    _: 1
  }, 8, ["href"]))
}
}

})